import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { SentryErrorBoundary } from '@paragon/client-tools';
import { ParagonThemeProvider } from '@paragon/themes';

import { store } from '../../store';
import { chTheme, darkTheme, lightTheme } from '../../themes';
import { RootComponent } from './RootComponent';

interface Props {
  readonly reduxStore: typeof store;
}

export default function MaterialManagerClient(props: Props) {
  return (
    <SentryErrorBoundary>
      <React.StrictMode>
        <BrowserRouter>
          <Provider store={props.reduxStore}>
            <ParagonThemeProvider darkTheme={darkTheme} lightTheme={lightTheme} chTheme={chTheme}>
              <RootComponent />
            </ParagonThemeProvider>
          </Provider>
        </BrowserRouter>
      </React.StrictMode>
    </SentryErrorBoundary>
  );
}
